// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7":"417d9014","188":"bb8e3542","914":"e6e242e1","963":"f3bf8664"}[chunkId] + ".css";
};